/**
 * GLDN PreProduct Cart Bridge (gldn85 / #364)
 *
 * PreProduct's charge-upfront flow normally submits to Shopify and then follows
 * its configured front-end redirect. The theme's native product form never sees
 * that submission, so Horizon cannot refresh or open its cart drawer.
 *
 * PreProduct documents ppCartSessionTransactionReady as its handoff event. By
 * setting detail.handled synchronously, this bridge accepts responsibility for
 * the native-cart add and prevents the app's redirect. The resulting Shopify
 * sections are then passed through Horizon's existing cart:update contract.
 */
(function () {
  'use strict';

  var SOURCE_ID = 'gldn-preproduct-cart-bridge';
  var STATUS_EVENT = 'gldn:preproduct-atc';

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      var id = component && component.dataset && component.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function emitStatus(state, item, message) {
    document.dispatchEvent(
      new CustomEvent(STATUS_EVENT, {
        detail: {
          state: state,
          variantId: item && item.id != null ? String(item.id) : null,
          quantity: item && Number(item.quantity) > 0 ? Number(item.quantity) : 1,
          message: message ? String(message).slice(0, 200) : null,
        },
      })
    );
  }

  function dispatchCartUpdate(response, item) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: response,
          sourceId: SOURCE_ID,
          data: {
            source: 'product-form-component',
            integrationSource: SOURCE_ID,
            itemCount: Number(item.quantity) || 1,
            variantId: String(item.id),
            sections: response.sections,
          },
        },
      })
    );
  }

  function dispatchCartError(item, error) {
    var message = error && error.message ? error.message : 'Unable to add this pre-order to the cart.';
    document.dispatchEvent(
      new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          sourceId: SOURCE_ID,
          data: {
            message: message,
            description: message,
            errors: null,
            variantId: item && item.id != null ? String(item.id) : null,
          },
        },
      })
    );
  }

  function buildPayload(item) {
    var line = {
      id: Number(item.id),
      quantity: Number(item.quantity) > 0 ? Number(item.quantity) : 1,
    };

    if (item.sellingPlan != null && item.sellingPlan !== '') {
      line.selling_plan = Number(item.sellingPlan);
    }
    if (item.properties && typeof item.properties === 'object') {
      line.properties = item.properties;
    }

    return {
      items: [line],
      sections: cartSectionIds().join(','),
      sections_url: window.location.pathname,
    };
  }

  function releaseModalSuccessGuard() {
    if (document.documentElement && document.documentElement.removeAttribute) {
      document.documentElement.removeAttribute('data-gldn-preproduct-cart-complete');
    }
  }

  function dismissPreproductModalAfterCartSuccess() {
    if (typeof window.gldnDismissPreproductModalAfterCartSuccess === 'function') {
      window.gldnDismissPreproductModalAfterCartSuccess();
      return;
    }

    if (document.documentElement) {
      if (document.documentElement.removeAttribute) {
        document.documentElement.removeAttribute('data-gldn-preproduct-modal-pending');
      }
      if (document.documentElement.setAttribute) {
        document.documentElement.setAttribute(
          'data-gldn-preproduct-cart-complete',
          'true'
        );
      }
    }

    var detailsNodes = document.querySelectorAll
      ? document.querySelectorAll('#pledge-details')
      : [];
    Array.prototype.forEach.call(detailsNodes, function (details) {
      if (!details) return;
      if (details.removeAttribute) {
        details.removeAttribute('data-gldn-personalizer-pending');
      }
      if (details.style) {
        if (details.style.setProperty) {
          details.style.setProperty('height', '0%', 'important');
        } else {
          details.style.height = '0%';
        }
      }
    });
  }

  async function addToNativeCart(item) {
    var theme = typeof Theme !== 'undefined' ? Theme : window.Theme;
    var cartAddUrl =
      theme && theme.routes && theme.routes.cart_add_url
        ? theme.routes.cart_add_url
        : '/cart/add.js';
    var response = await fetch(cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(buildPayload(item)),
    });
    var body = await response.json();

    if (!response.ok || body.status || body.errors) {
      throw new Error(body.description || body.message || 'Unable to add this pre-order to the cart.');
    }

    item.addedToNativeCart = true;
    dismissPreproductModalAfterCartSuccess();
    dispatchCartUpdate(body, item);
    emitStatus('success', item);
  }

  window.addEventListener('ppCartSessionTransactionReady', function (event) {
    try {
      var detail = event && event.detail;
      var item = detail && detail.itemAddition;
      if (!detail || detail.handled || !item || item.id == null) return;

      // PreProduct checks this immediately after dispatch. Set it before the
      // asynchronous cart request so its own add/redirect path cannot race us.
      detail.handled = true;
      releaseModalSuccessGuard();
      emitStatus('intercepted', item);

      addToNativeCart(item).catch(function (error) {
        dispatchCartError(item, error);
        emitStatus('error', item, error && error.message);
      });
    } catch (error) {
      emitStatus('error', null, error && error.message);
    }
  });
})();
